import React from "react";
import "./CustomDateHeader.css";

const CustomDateHeader = ({ date, label, onAddAppointment }) => {
  // Get current date for comparison
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  // Compare with the date prop
  const dateMonth = date.getMonth();
  const dateDay = date.getDate();

  // Determine CSS classes
  const isOffRange = dateMonth !== currentMonth;
  const isCurrentDay = dateDay === currentDay;

  let dateLabelClass = "date-label";
  if (isCurrentDay) {
    dateLabelClass += " current-day";
  } else if (isOffRange) {
    dateLabelClass += " off-range";
  }

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleAddClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onAddAppointment) {
      onAddAppointment(date);
    }
  };

  return (
    <div className="custom-date-header" onClick={handleClick}>
      <span className={dateLabelClass}>{label}</span>
      <button
        className="add-appointment-btn"
        onClick={handleAddClick}
        title="Add appointment"
      >
        <i className="bi bi-plus"></i>
      </button>
    </div>
  );
};

export default CustomDateHeader;
